var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserPic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.672,
    height: 31.672,
    viewBox: "0 0 31.672 31.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user_1_",
    "data-name": "user (1)",
    d: "M17.836,2A15.836,15.836,0,1,0,33.672,17.836,15.854,15.854,0,0,0,17.836,2Zm9.632,24.974a10.743,10.743,0,0,0-19.255.01,13.134,13.134,0,0,1-3.679-9.148,13.3,13.3,0,1,1,26.6,0,13.135,13.135,0,0,1-3.67,9.138ZM17.836,8.334a5.7,5.7,0,1,0,5.7,5.7A5.7,5.7,0,0,0,17.836,8.334Z",
    transform: "translate(-2 -2)",
    fill: "#d6dced"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserPic);
export default __webpack_public_path__ + "static/media/user_pic.a2bd9c1c969e26cd280a2cf99762bf34.svg";
export { ForwardRef as ReactComponent };